import React from 'react'
import { Route,Routes } from 'react-router-dom'

import DeckHome from '../pages/DeckHome';
import DeckTerm from '../pages/DeckTerm';
import DeckPrivacy from '../pages/DeckPrivacy';
export default function AdhanRoute() {
  return (
    <Routes>
        <Route path="/deck" element={<DeckHome />} />
        <Route path="/deck/privacy" element={<DeckPrivacy />} />
        <Route path="/deck/terms" element={<DeckTerm />} />
    </Routes>
  )
}
